export const enum VoucherDiscountType {
	Percent = 1,
	Amount = 2
}

export interface Voucher {
	taxAmount: number;
	taxPercent: number;
	totalAmount: number;
	voucherCode: string;
	discount: number;
	discountType: VoucherDiscountType;
	discountAmount: number;
	priceWithDiscount: number;
	priceAfterDiscount: number;
}

export interface MyVoucher {
	id: string;
	communityPartnerId: string;
	voucherCode: string;
	title: string;
	discount: number;
	usageLimitCount: number;
	usedCount: number;
	createdAt: string;
	subscriptionPlanCode: string;
	expireDate: string;
	isExpired: boolean;
	availableRegions: any;
	isAutoGenerated: boolean;
	isActive: boolean;
	voucherUsageInfos: VoucherUsageInfo[];
	discountType: VoucherDiscountType;
	availableInSubscriptionRenewal: boolean;
}

export interface VoucherUsageInfo {
	businessPartnerEmail: string;
	businessPartnerId: string;
	businessPartnerLogo: { url: string; thumbnail: string };
	businessPartnerName: string;
	id: string;
	paymentReference: string;
	subscriptionId: string;
	subscriptionPaymentId: string;
	usageDateTime: string;
}
